/**
 * API 请求封装
 * 基于 fox-blog-api.md 文档
 */

const BASE_URL = 'https://uniformfox.slybootslion.com/api/v1/fox_blog';

// 获取存储的 API Key
const getApiKey = () => {
  return localStorage.getItem('fox_blog_api_key') || '';
};

// 设置 API Key
export const setApiKey = (apiKey) => {
  localStorage.setItem('fox_blog_api_key', apiKey);
};

// 清除 API Key
export const clearApiKey = () => {
  localStorage.removeItem('fox_blog_api_key');
};

// 检查是否已登录
export const isAuthenticated = () => {
  return !!getApiKey();
};

// 通用请求函数
const request = async (url, options = {}) => {
  const apiKey = getApiKey();
  
  const headers = {
    'Content-Type': 'application/json',
    ...(apiKey && { 'X-API-Key': apiKey }),
    ...options.headers,
  };

  try {
    const response = await fetch(`${BASE_URL}${url}`, {
      ...options,
      headers,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || '请求失败');
    }

    return data;
  } catch (error) {
    console.error('API 请求错误:', error);
    throw error;
  }
};

/**
 * 博客 API
 */
export const blogApi = {
  // 获取博客列表
  getList: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.page_size) queryParams.append('page_size', params.page_size);
    if (params.user_id) queryParams.append('user_id', params.user_id);
    if (params.tag) queryParams.append('tag', params.tag);
    if (params.keyword) queryParams.append('keyword', params.keyword);
    if (params.is_private !== undefined) queryParams.append('is_private', params.is_private);
    
    const query = queryParams.toString();
    return request(`?${query}`, { method: 'GET' });
  },

  // 获取博客详情
  getDetail: (uuid) => {
    return request(`/${uuid}`, { method: 'GET' });
  },

  // 创建博客
  create: (data) => {
    return request('', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // 更新博客
  update: (uuid, data) => {
    return request(`/${uuid}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  // 删除博客
  delete: (uuid) => {
    return request(`/${uuid}`, { method: 'DELETE' });
  },
};

export default {
  blogApi,
  setApiKey,
  clearApiKey,
  isAuthenticated,
};
